import AccountWidget from './AccountWidget';

export default AccountWidget;
